<div class="footer-detail" *ngIf="!simpleFooter">
  <!-- NOT EDIT -->
  <ng-template [ngIf]="!isEdit">
    <!-- new order duplicate -->
    <button *ngIf="!isExchange" (click)="save(null)" class="btn brand btn-primary"
            [disabled]="!form.valid || !disabledSaveBtn || extraInfo[0]?.color==='red' || extraInfo[1]?.color==='red'">
      {{'SUBMIT_DUPLICATE' | translate:locale.language}}
    </button>

    <!-- new order renew -->
    <button *ngIf="!isExchange" (click)="save(true)" class="btn brand btn-primary"
            [disabled]="!form.valid || !disabledSaveBtn || extraInfo[0]?.color==='red' || extraInfo[1]?.color==='red'">
      {{'SUBMIT_RENEW' | translate:locale.language}}
    </button>

    <!-- new order save -->
    <button *ngIf="!isExchange" (click)="save(false)" class="btn brand btn-primary"
            [disabled]="!form.valid || !disabledSaveBtn || extraInfo[0]?.color==='red' || extraInfo[1]?.color==='red'">
      {{'SUBMIT' | translate:locale.language}}
    </button>

    <!-- exchange order save -->
    <button *ngIf="isExchange" (click)="save(false)" class="btn brand btn-primary" [disabled]="!form.valid || !disabledSaveBtn">
      {{'SUBMIT' | translate:locale.language}}
    </button>

    <!-- new and exchange order reset -->
    <button (click)="cancel()" class="btn btn-default" [disabled]="form.pristine">{{'CANCEL' | translate:locale.language}}</button>
  </ng-template>
  <!-- errors -->
  <span class="errors-form" *ngIf="(countErrors()) > 0">{{countErrors()}} {{'ERROR' | translate:locale.language}}</span>
  <!-- spinner -->
  <div *ngIf="!isExchange && form.get(['addresses']).valid && form.get(['misc', 'expeditionForm', 'expeditionDate']).valid  && !disabledSaveBtn">
    <div class="fa-1x"><i class="fas fa-circle-notch fa-spin"></i></div>
  </div>
  <!-- extra info -->
  <span [ngStyle]="{'color': extraInfo[0]?.color}" *ngIf="extraInfo[0]" style="padding-right: 10px ; padding-left: 10px">
         <strong>  {{extraInfo[0]?.message | translate:locale.language }} </strong>
         <span *ngIf=extraInfo[0]?.extraData>{{ extraInfo[0]?.extraData }}</span>
   </span>
  <span [ngStyle]="{'color': extraInfo[1]?.color}" *ngIf="extraInfo[1]" style="padding-right: 10px ; padding-left: 10px">
         <strong>   {{ extraInfo[1]?.message | translate:locale.language }} </strong>
         <span *ngIf=extraInfo[1]?.extraData>{{ extraInfo[1]?.extraData }}</span>
   </span>
  <!-- edit order cancel -->
  <button *ngIf="order && (!order.sfProductionCaseID) && isEdit && (isRolesBoOrder || isRolesOrderCancelRole)" (click)="cancelOrder()"
          class="btn btn-danger">{{'CANCEL_ORDER' | translate:locale.language}}</button>

  <button *ngIf="order && isEdit && order.status > 1 && (isRolesBoOrder || isRolesOrderCancelRole)" (click)="resetOrders()" class="btn btn-default">{{'ORDER_LIST_RESET_ORDER' | translate:locale.language}}</button>
</div>

<div class="footer-detail" *ngIf="simpleFooter">
  <ng-template [ngIf]="!isEdit">

    <!-- new  save -->
    <button (click)="save(false)" class="btn brand btn-primary" [disabled]="!form.valid || !disabledSaveBtn">
      {{'SUBMIT' | translate:locale.language}}
    </button>
    <!-- new and exchange order reset -->
    <button (click)="cancel()" class="btn btn-default">{{'CANCEL' | translate:locale.language}}</button>
    <!-- errors -->
    <span class="errors-form" *ngIf="(countErrors()) > 0">{{countErrors()}} {{'ERROR' | translate:locale.language}}</span>
    <span *ngIf="extraInfo">
      <span [ngStyle]="{'color': extraInfo[0]?.color}" *ngIf="extraInfo[0]" style="padding-right: 10px ; padding-left: 10px">
           <strong>  {{extraInfo[0]?.message | translate:locale.language }} </strong>
           <span *ngIf=extraInfo[0]?.extraData>{{ extraInfo[0]?.extraData }}</span>
      </span>
   </span>
  </ng-template>
  <ng-template [ngIf]="isEdit">
    <span *ngIf="extraInfo">
      <span [ngStyle]="{'color': extraInfo[0]?.color}" *ngIf="extraInfo[0]" style="padding-right: 10px ; padding-left: 10px">
           <strong>  {{extraInfo[0]?.message | translate:locale.language }} </strong>
           <span *ngIf=extraInfo[0]?.extraData>{{ extraInfo[0]?.extraData }}</span>
      </span>
   </span>
    <div *ngIf="isDelete">
      <button (click)="cancel()"  class="btn btn-danger">{{'DELETE_DELETE' | translate:locale.language}}</button>
    </div>
  </ng-template>

  <div *ngIf="isSiteShippingEdit">
    <button (click)="cancel()" class="btn btn-default">{{'BACK' | translate:locale.language}}</button>
  </div>

</div>



<div *ngIf="false">
  <pre>isExchange:{{isExchange}}</pre>
  <pre>addresses valid:{{form.get(['addresses']).valid}}</pre>
  <pre>date valid:{{form.get(['misc', 'expeditionForm', 'expeditionDate']).valid}}</pre>
  <pre>disabledSaveBtn:{{disabledSaveBtn}}</pre>
</div>

